/**
 * Created by andrey on 01.06.16.
 */

module.exports = {
    scripts: {
        'transition': true,
        'alert': false,
        'button': true,
        'carousel': false,
        'collapse': true,
        'dropdown': false,
        'modal': false,
        'tooltip': false,
        'popover': false,
        'scrollspy': false,
        'tab': false,
        'affix': false
    },

    styles: {
        'mixins': true,

        'normalize': true,
        'print': true,

        'scaffolding': true,
        'type': true,
        'code': true,
        'grid': true,
        'tables': true,
        'forms': true,
        'buttons': true,

        'component-animations': true,
        'glyphicons': true,
        'dropdowns': true,
        'button-groups': true,
        'input-groups': true,
        'navs': true,
        'navbar': true,
        'breadcrumbs': true,
        'pagination': true,
        'pager': true,
        'labels': true,
        'badges': true,
        'jumbotron': true,
        'thumbnails': true,
        'alerts': true,
        'progress-bars': true,
        'media': true,
        'list-group': true,
        'panels': true,
        'wells': true,
        'close': true,

        'modals': true,
        'tooltip': true,
        'popovers': true,
        'carousel': false,

        'utilities': true,
        'responsive-utilities': true
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/styles/bootstrap/bootstrap.config.js
// module id = 2889
// module chunks = 18